/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';
import store, { history } from './store';

import { Spin } from 'antd';

import Root from './screens/Root';

import './styles/css/main.css';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router history={history}>
          <Suspense fallback={<Spin />}>
            <Root />
          </Suspense>
        </Router>
      </Provider>
    </I18nextProvider>
  );
}

export default App;
